// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";

// Define a service using a base URL and expected endpoints
export const LevelsApi = createApi({
  reducerPath: "LevelsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_RESSOURCES,
    prepareHeaders: (headers) => {
      headers.set("Cache-Control", "no-cache");
      headers.set("Pragma", "no-cache");
      headers.set("Expires", "0");

      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllLevels: builder.query<any, void>({
      query: () => ({
        url: "/levels/findAll/newLogic",
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllLevelsQuery } = LevelsApi;
